class templateImagesLoader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.addEventListener('click', this.handleMenuInteraction, { once: true });
		this.addEventListener('mouseover', this.handleMenuInteraction, { once: true });
	}

  removeEvents() {
    this.removeEventListener('click', this.handleMenuInteraction);
		this.removeEventListener('mouseover', this.handleMenuInteraction);
  }

	handleMenuInteraction() {
    this.transformTemplateLazyImages();
    this.removeEvents()
	}

	transformTemplateLazyImages() {    
		const templates = this.querySelectorAll('.header-bottom__image-template');
		templates.forEach(template => {
			const content = template.content.cloneNode(true);
			template.replaceWith(content);
		});
	}
}

customElements.define('template-images-loader', templateImagesLoader);
